var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3DescentSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v4H47.83L34.48 73.92l-2.11-3.73L46.68 59H69zM50 37H40V8h-4v29H26l12 13 12-13zM7 63h24v-4H7v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Descent_switch.b4142e8e.svg";
export { SvgJ3DescentSwitch as ReactComponent };